module.exports = __webpack_public_path__ + "img/icon-differentials_09.b773f6e2.svg";